import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux'
import { Store } from './store'

import App from './App';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={Store}>
    <App />
  </Provider>,
  rootElement
);
  
serviceWorker.unregister();

